import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { CompanyService, ContactService, UtilityService } from "src/app/services";
import { ContactDialogService } from "../contact-dialog";
import { ConfirmDialogService, ConfirmDialogOptions } from "src/app/shared";
import { SessionDataService } from "src/app/services/session-data.service";
import { ContactWeb } from "src/app/models";
import { Subscription } from "rxjs";
import { ContactListDialogComponent } from "../contact-list-dialog/contact-list-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-contact-list-item",
  templateUrl: "./contact-list-item.component.html",
  styleUrls: ["./contact-list-item.component.scss"]
})
export class ContactListItemComponent implements OnInit, OnDestroy
{

  @Input() contact: ContactWeb;

  private phoneDescriptionsSubscription: Subscription;
  phoneDescription: string;

  private webSettingsSubscription: Subscription;
  areContactsEditable: boolean = true;

  isEmployee: boolean;


  constructor(
    private contactService: ContactService,
    private contactDialogService: ContactDialogService,
    private confirmDialogService: ConfirmDialogService,
    private sessionDataService: SessionDataService,
    public dialog: MatDialog,
    private utilityService: UtilityService,
    private companyService: CompanyService
  )
  {


  }

  ngOnInit()
  {

    this.phoneDescriptionsSubscription = this.utilityService.phoneDescriptions.subscribe(x =>
    {
      if (this.contact.Type)
      {
        const val = Number(this.contact.Type);
        const element = x.find(e => e.Value === val);
        if (element)
        {
          this.phoneDescription = element.Message;
        }
      }
    });
    this.isEmployee = this.sessionDataService.IsEmployee;
    this.webSettingsSubscription = this.companyService.webSettings.subscribe(w =>
    {
      if (w)
      {
        this.areContactsEditable = w.AreContactsEditable ?? true;
      }
    });

  }

  ngOnDestroy()
  {
    this.phoneDescriptionsSubscription.unsubscribe();
    this.webSettingsSubscription.unsubscribe();
  }

  handleEditClick(): void
  {
    this.contactDialogService.openDialog(this.contact);
  }

  isContactEditable(): boolean
  {
    return this.areContactsEditable || this.isEmployee;
  }

  handleDeleteClick(): void
  {
    const dialogData = new ConfirmDialogOptions("Delete Contact", `Delete Contact ${ this.contact.FirstName } ${ this.contact.LastName }?`);
    this.confirmDialogService
      .openDialog(dialogData)

      .afterClosed().subscribe(async result =>
      {
        if (result)
        {
          this.contactService.deleteContact(this.contact);
        }
        await new Promise(r => setTimeout(r, 1000));
        if (this.contactService.checkEmails())
        {
          this.dialog.open(ContactListDialogComponent, {
            disableClose: true,
            width: "600px",
            maxHeight: "90%",
            maxWidth: "90%",
          });
        }
      });
  }

}
